import React from "react";
import ReactDOM from "react-dom/client";

import "mapbox-gl/dist/mapbox-gl.css";
import { ThemeProvider } from "@material-tailwind/react";

import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
